export default {
  xmComputeField:'xmInputCell',
  xmReadOnly:'xmInputCell',
  xmHidden:'xmInputCell',
  xmEditor:'xmInputCell',
  xmDomainSel:'xmInputCell',
  exchangeRate:'xmInputCell',
  xmCheckboxGroup:'xmInputCell',
  xmSelect:'Select',
  /** 不良品项[编辑] 非编辑态以标签展示缺陷项 */
  defectiveItemEditor:'xmErrorProSetCell',
}
